import React, { useCallback, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'

import Step from '../../../../../../../features/components/Forms/StepForm/Step'
import RadioBlock from '../../../../../../../components/Form/RadioBlock'
import AppsSection from '../../../../../reusableFormFields/AppsSection'
import UrlsSection from '../../../../../reusableFormFields/UrlsSection'
import ChannelsSection from '../../../../../reusableFormFields/ChannelsSection'

import { clearGetDv360Channels } from '../../../../../../../modules/actions/dv360Constants'
import { dv360ChannelsWasLoadedSelector } from '../../../../../../../modules/selectors/dv360Constants'

import { TARGET_SPECIFIC_URLS_OR_APPS, YES_USING_PRE_SAVED_SITE_LISTS } from '../../fields'
import { OPTION_NO, OPTION_YES } from '../../../../../../../constants/forms'

const UrlsAndAppsStep = ({ formik, handleStepChange }) => {
  const dispatch = useDispatch()
  const { t } = useTranslation()

  const dv360ChannelsWasLoaded = useSelector(dv360ChannelsWasLoadedSelector)

  const { values, setFieldValue } = formik

  const handleContinue = useCallback(() => {
    handleStepChange()
  }, [handleStepChange])

  useEffect(() => {
    return () => {
      if (dv360ChannelsWasLoaded) {
        dispatch(clearGetDv360Channels())
      }
    }
  }, [dispatch, dv360ChannelsWasLoaded])

  return (
    <Step stepTitle="Would you like to target specific URLs or apps?" handleContinue={handleContinue}>
      <RadioBlock
        setFieldValue={setFieldValue}
        id={TARGET_SPECIFIC_URLS_OR_APPS + OPTION_NO}
        name={TARGET_SPECIFIC_URLS_OR_APPS}
        value={OPTION_NO}
        selectedValue={values[TARGET_SPECIFIC_URLS_OR_APPS]}
        label={t('No')}
      />
      <RadioBlock
        setFieldValue={setFieldValue}
        id={TARGET_SPECIFIC_URLS_OR_APPS + YES_USING_PRE_SAVED_SITE_LISTS}
        name={TARGET_SPECIFIC_URLS_OR_APPS}
        value={YES_USING_PRE_SAVED_SITE_LISTS}
        selectedValue={values[TARGET_SPECIFIC_URLS_OR_APPS]}
        label={t('Yes, using pre-saved site lists')}
      >
        <ChannelsSection formik={formik} />
      </RadioBlock>
      <RadioBlock
        setFieldValue={setFieldValue}
        id={TARGET_SPECIFIC_URLS_OR_APPS + OPTION_YES}
        name={TARGET_SPECIFIC_URLS_OR_APPS}
        value={OPTION_YES}
        selectedValue={values[TARGET_SPECIFIC_URLS_OR_APPS]}
        label={t('Yes, manually entering the sites and apps')}
      >
        <UrlsSection formik={formik} />
        <AppsSection formik={formik} />
      </RadioBlock>
    </Step>
  )
}

export default UrlsAndAppsStep
